/**
 * Calculate time elapsed in human-readable format
 * @param date - Date string or Date object
 * @returns Human-readable time elapsed (e.g., "5 days ago", "3 weeks ago")
 */
export function getTimeElapsed(date: string | Date): string {
  const now = new Date();
  const past = typeof date === 'string' ? new Date(date) : date;
  const diffMs = now.getTime() - past.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays === 0) {
    return 'Today';
  } else if (diffDays === 1) {
    return '1 day ago';
  } else if (diffDays < 7) {
    return `${diffDays} days ago`;
  } else if (diffDays < 14) {
    return '1 week ago';
  } else if (diffDays < 21) {
    return '2 weeks ago';
  } else if (diffDays < 30) {
    return '3 weeks ago';
  } else if (diffDays < 60) {
    return '1 month ago';
  } else if (diffDays < 90) {
    return '2 months ago';
  } else if (diffDays < 120) {
    return '3 months ago';
  } else if (diffDays < 365) {
    const months = Math.floor(diffDays / 30);
    return `${months} months ago`;
  } else {
    const years = Math.floor(diffDays / 365);
    return `${years} ${years === 1 ? 'year' : 'years'} ago`;
  }
}
